<h1 mat-dialog-title>Request signing of {{data.document.filename}}</h1>
<form [formGroup]="form" class="sign-document-request-form" (ngSubmit)="onSend(submitBtn)">
  <div mat-dialog-content>
    <div mat-line>{{data.document.type_description}} / {{data.document.created_at | date:'short'}}</div>
    <div mat-line>{{data.document.name}} {{data.document.notes}}</div>


    <mat-form-field class="full-width">
      <mat-label>Name</mat-label>
      <input matInput placeholder="Name of the document" formControlName="name" />
    </mat-form-field>

    <mat-checkbox class="full-width" formControlName="sign_as_inviter">Sign as Corona Capital</mat-checkbox>

    <div formArrayName="signers" *ngFor="let signer of form.get('signers')['controls']; let i = index;">
      <div [formGroupName]="i">

        <div class="signer-title" mat-line>Signer {{i + 1}}:</div>

        <mat-form-field class="full-width">
          <mat-label>Name</mat-label>
          <input matInput placeholder="Signer name" formControlName="name" />
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>Email</mat-label>
          <input type="email" matInput placeholder="first.last@example.com" formControlName="email" />
        </mat-form-field>

        <mat-form-field class="full-width">
          <mat-label>SMS</mat-label>
          <input matInput placeholder="+358...." formControlName="sms" />
        </mat-form-field>
      </div>
    </div>

    <button mat-raised-button type="button" (click)="addSigner()">Add Signer</button>

  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-button [disabled]="!form.valid" #submitBtn>Send</button>
  </div>
</form>
